import React from 'react';
import { DrawerV2, PopoverV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

const POPPER_OPTIONS = {
  offset: {
    offset: ({ reference }: { reference: { height: number } }) => {
      return [-16, reference.height * -1 - 8] as [number, number];
    },
  },
};

type GuideWrapperProps = Readonly<{
  children: React.ReactNode;
  trigger: React.ReactElement;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}>;

export const MobileWrapper = ({ children, trigger, isOpen, onOpen, onClose }: GuideWrapperProps) => {
  const handleTrigger = () => {
    onOpen();
  };
  const triggerClone = React.cloneElement(trigger, {
    onClick: handleTrigger,
  });
  return (
    <>
      <DrawerV2
        onClose={onClose}
        size="auto"
        isOpen={isOpen}
        anchor="bottom"
        useBackdrop
        overrides={{
          Content: {
            props: {
              height: 'unset',
              borderRadius: '0.5rem 0.5rem 0 0',
              width: '100vw',
              padding: '0',
              maxHeight: '100%',
              overflow: 'auto',
            },
          },
        }}
      >
        <DrawerV2.Body padding={0}>{children}</DrawerV2.Body>
      </DrawerV2>
      {triggerClone}
    </>
  );
};

export const DesktopWrapper = ({ children, trigger, isOpen, onOpen, onClose }: GuideWrapperProps) => {
  return (
    <PopoverV2
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      popperOptions={POPPER_OPTIONS}
    >
      <PopoverV2.Trigger>{trigger}</PopoverV2.Trigger>
      <PopoverV2.Content
        borderRadius={3}
        overflow={'hidden'}
        maxWidth={`min(90vw, ${pxToRem(404)})`}
      >
        {children}
      </PopoverV2.Content>
    </PopoverV2>
  );
};
